import { Repository } from './repository'

export abstract class FirstoreRepository<T> extends Repository<T> {
  //
}
